export type AiModelKey = 'claude-haiku-5-5' | 'minimax-m2-5' | 'glm-5';

export const DEFAULT_AI_MODEL: AiModelKey = 'claude-haiku-5-5';

export const AI_MODEL_OPTIONS: Array<{ value: AiModelKey; label: string }> = [
  { value: 'claude-haiku-5-5', label: 'Haiku 5.5' },
  { value: 'minimax-m2-5', label: 'MiniMax M2.5' },
  { value: 'glm-5', label: 'GLM 5' },
];
